"use client";

import { Subtitle } from "@tremor/react";
import { LinkWithIcon } from "components/LinkWithIcon";
import { Session } from "next-auth";
import { Disclosure } from "@headlessui/react";
import { IoChevronUp } from "react-icons/io5";
import { useIncidents, usePollIncidents } from "utils/hooks/useIncidents";
import { MdFlashOn } from "react-icons/md";
import clsx from "clsx";
import { DEFAULT_INCIDENTS_PAGE_SIZE, DEFAULT_INCIDENTS_CEL, DEFAULT_INCIDENTS_SORTING } from "@/entities/incidents/model/models";
type IncidentsLinksProps = {
  session: Session | null;
};
export const IncidentsLinks = ({
  session
}: IncidentsLinksProps) => {
  const isNOCRole = session?.userRole === "noc";
  const {
    data: incidents,
    mutate
  } = useIncidents({
    candidate: false,
    predicted: null,
    limit: 0,
    offset: 0,
    sorting: DEFAULT_INCIDENTS_SORTING,
    cel: DEFAULT_INCIDENTS_CEL
  }, {});
  usePollIncidents(mutate);
  if (isNOCRole) {
    return null;
  }
  return <Disclosure as="div" className="space-y-0.5" defaultOpen data-sentry-element="Disclosure" data-sentry-component="IncidentsLinks" data-sentry-source-file="IncidentLinks.tsx">
      <Disclosure.Button className="w-full flex justify-between items-center px-2" data-sentry-element="unknown" data-sentry-source-file="IncidentLinks.tsx">
        {({
        open
      }) => <>
            <Subtitle className="text-xs ml-2 text-gray-900 font-medium uppercase">
              INCIDENTS
            </Subtitle>
            <IoChevronUp className={clsx({
          "rotate-180": open
        }, "mr-2 text-slate-400")} />
          </>}
      </Disclosure.Button>

      <Disclosure.Panel as="ul" className="space-y-0.5 p-1 pr-1" data-sentry-element="unknown" data-sentry-source-file="IncidentLinks.tsx">
        <li className="relative">
          <LinkWithIcon href="/incidents" icon={MdFlashOn} count={incidents?.count} testId="incidents" data-sentry-element="LinkWithIcon" data-sentry-source-file="IncidentLinks.tsx">
            <Subtitle className="text-xs" data-sentry-element="Subtitle" data-sentry-source-file="IncidentLinks.tsx">Incidents</Subtitle>
          </LinkWithIcon>
        </li>
      </Disclosure.Panel>
    </Disclosure>;
};